export const services = [
  {
    id: "visual-production",
    title: "Visual Production",
    tagline: "Cinematic storytelling that commands attention",
    description:
      "We craft high-end visual content that tells your brand story with impact. From corporate documentaries and product showcases to social media campaigns and live events, our professional videography and photography services are designed to capture attention and leave a lasting impression. Using drone cinematography, event coverage, and advanced post-production techniques, including color grading, motion graphics, and sound design, we ensure your visuals not only look stunning but also drive engagement and measurable results.",
    shortdescription:
      "High-end visual content creation designed to elevate brand perception and capture attention across platforms.",
    features: [
      {
        title: "Commercial Videography",
        description: "Brand films, product showcases, testimonials",
      },
      {
        title: "Professional Photography",
        description: "Product, corporate, lifestyle, event coverage",
      },
      {
        title: "Drone Cinematography",
        description: "Aerial perspectives that elevate storytelling",
      },
      {
        title: "Event Documentation",
        description: "Conferences, launches, corporate gatherings",
      },
      {
        title: "Social Media Content",
        description: "Platform-optimized short-form video",
      },
      {
        title: "Post-Production Excellence",
        description: "Color grading, motion graphics, sound design",
      },
    ],
    deliverables: [
      "Full HD/4K video production",
      "Professional photography packages",
      "Drone footage and aerial photography",
      "Event highlight reels",
      "Social media content packages",
      "Raw footage and source files",
      "Licensed music and sound design",
      "Multiple format exports",
    ],
    skills: [
        { name: "Cinematography", level: 95, description: "Commercial and branded visual storytelling" },
        { name: "Lighting & Setups", level: 92, description: "Controlled studio and on-location lighting" },
        { name: "Post-Production", level: 90, description: "Editing, color grading, and finishing" },
        { name: "Aerial & Motion", level: 88, description: "Drone and dynamic camera movement" }
      ],
    timeline: "1 day – 6 weeks",
    priceFrom: "KES 100,000",
    price: 100000,
    image: "https://images.unsplash.com/photo-1675635069927-cf0522ccdf6e",
    alt: "Professional videographer filming with cinema camera",
    iconName: "Video",
    color: "from-primary/90 to-accent/90",
    link: "/corporate-solutions-services#visual-production",
  },
  {
    id: "strategic-branding",
    title: "Strategic Branding",
    tagline: "Identity systems that build market dominance",
    description:
      "We go beyond logo design to engineer complete brand ecosystems. Our strategic branding services help businesses define their positioning, craft a unique voice, and create visual systems that communicate credibility and authority. From workshops that clarify your value proposition to full visual identity design:including logo, typography, color systems, and collateral—you get a cohesive, premium brand presence that resonates with your audience and sets you apart in your market",
    shortdescription:
      "Strategic brand development that defines identity, positioning, and consistency across all touchpoints.",
    features: [
      {
        title: "Brand Strategy Workshop",
        description: "Positioning, differentiation, value proposition",
      },
      {
        title: "Visual Identity Design",
        description: "Logo, color systems, typography",
      },
      { title: "Brand Messaging", description: "Voice, tone, key messages" },
      {
        title: "Brand Guidelines",
        description: "Comprehensive usage documentation",
      },
      {
        title: "Collateral Design",
        description: "Business cards, presentations",
      },
      { title: "Brand Implementation", description: "Rollout strategy" },
    ],
    deliverables: [
      "Brand strategy document",
      "Complete visual identity",
      "Logo variations",
      "Color palette",
      "Brand guidelines",
      "Collateral templates",
      "Digital asset library",
      "Implementation roadmap",
    ],
    skills: [
        { name: "Brand Identity Systems", level: 92, description: "Logos, typography, and visual language" },
        { name: "Brand Positioning", level: 88, description: "Messaging and market differentiation" },
        { name: "Creative Direction", level: 90, description: "Cross-platform brand coherence" },
        { name: "Guidelines & Assets", level: 85, description: "Usable brand documentation" }
      ],
    timeline: "3–6 weeks",
    priceFrom: "KES 80,000",
    price: 80000,
    image:
      "https://img.rocket.new/generatedImages/rocket_gen_img_1654ebf47-1764773611909.png",
    alt: "Designer working on brand identity",
    iconName: "Layers",
    color: "from-secondary/90 to-yellow-600/90",
    link: "/corporate-solutions-services#strategic-branding",
  },
  {
    id: "digital-presence",
    title: "Website & Digital Presence",
    tagline: "Websites that convert visitors into customers",
    description:
      "We design and develop purpose-built websites optimized for conversion, usability, and search engine performance. Every site we build is responsive, scalable, and tailored to your user journey, ensuring visitors stay engaged and take action. From wireframing and UX/UI design to development, CMS integration, and analytics setup, we deliver a complete digital platform that establishes credibility and drives measurable results. Our technical SEO foundation ensures your site is discoverable, while ongoing performance optimization keeps you ahead of the competition.",
    shortdescription:
      "Purpose-built digital platforms that establish credibility and drive conversion.",
    features: [
      { title: "Website Strategy", description: "User journey mapping" },
      { title: "UX/UI Design", description: "Wireframes and design" },
      { title: "Development", description: "Responsive and scalable" },
      { title: "SEO Foundation", description: "Technical SEO" },
      { title: "CMS Integration", description: "Easy management" },
      { title: "Analytics Setup", description: "Tracking and reporting" },
    ],
    deliverables: [
      "Custom design",
      "Responsive development",
      "CMS",
      "SEO setup",
      "Performance optimization",
      "Security",
      "Analytics",
      "Documentation",
    ],
     skills: [
        { name: "Website Design", level: 90, description: "Modern, responsive UI/UX" },
        { name: "Frontend Development", level: 88, description: "Performance-focused builds" },
        { name: "SEO Foundations", level: 82, description: "Search visibility and structure" },
        { name: "Analytics & Tracking", level: 80, description: "User behavior and performance insights" }
      ],
    timeline: "4–8 weeks",
    priceFrom: "KES 150,000",
    price: 150000,
    image:
      "https://img.rocket.new/generatedImages/rocket_gen_img_153ae58e0-1766470511581.png",
    alt: "Web developer coding",
    iconName: "Globe",
    color: "from-yellow-600/90 to-primary/90",
    link: "/corporate-solutions-services#digital-presence",
  },
  {
    id: "social-media",
    title: "Social Media Authority",
    tagline: "Content systems that build engaged communities",
    description:
      "We create strategic social media ecosystems that grow audiences, boost engagement, and establish authority. Through content planning, creation, community management, and influencer partnerships, we ensure your brand maintains a consistent presence across platforms. Our approach blends creative storytelling with analytics-driven strategies to transform followers into loyal customers and advocates. From content calendars and platform-optimized graphics to paid campaigns and performance analysis, we deliver a comprehensive social media solution that drives real business results.",
    shortdescription:
      "Consistent and strategic content systems that grow audience, engagement, and brand authority.",
    features: [
      { title: "Social Strategy", description: "KPIs and pillars" },
      { title: "Content Creation", description: "Graphics and video" },
      { title: "Community Management", description: "Engagement" },
      { title: "Influencer Partnerships", description: "Outreach" },
      { title: "Paid Campaigns", description: "Ads and optimization" },
      { title: "Analytics", description: "Insights" },
    ],
    deliverables: [
      "Strategy",
      "Content calendar",
      "Graphics/videos",
      "Captions/hashtags",
      "Community management",
      "Reports",
      "Competitor analysis",
      "Optimization",
    ],
    skills: [
        { name: "Content Strategy", level: 90, description: "Planned, goal-driven posting" },
        { name: "Short-Form Video", level: 93, description: "Reels, Shorts, and TikTok formats" },
        { name: "Community Engagement", level: 85, description: "Audience interaction and growth" },
        { name: "Platform Optimization", level: 88, description: "Native content per platform" }
      ],
    timeline: "Monthly retainer",
    priceFrom: "KES 50,000/month",
    price: 50000,
    image:
      "https://img.rocket.new/generatedImages/rocket_gen_img_1b18e1ef3-1766952080512.png",
    alt: "Social media manager",
    iconName: "Share2",
    color: "from-accent/90 to-secondary/90",
    link: "/corporate-solutions-services#social-media",
  },
  {
    id: "campaign-engineering",
    title: "Promotional Campaigns & Advertising",
    tagline: "Integrated campaigns that drive growth",
    description: "We design and execute integrated multi-channel campaigns that drive business growth. From campaign strategy and creative development to media planning, paid advertising, and performance analysis, every element is engineered for visibility, engagement, and measurable ROI. Our team ensures campaigns not only reach the right audience but convert them into tangible business outcomes. Whether launching a new product, promoting an event, or building brand awareness, we deliver end-to-end campaign solutions that maximize impact and drive results.",
    shortdescription:
      "Integrated promotional campaigns engineered for visibility, conversion, and measurable results.",
    features: [
      { title: "Campaign Strategy", description: "Objectives and targeting" },
      { title: "Creative Development", description: "Concepts and assets" },
      { title: "Media Planning", description: "Budget allocation" },
      { title: "Paid Advertising", description: "Google/Meta/LinkedIn" },
      { title: "Management", description: "Execution and optimization" },
      { title: "Performance Analysis", description: "ROI tracking" },
    ],
    deliverables: [
      "Strategy doc",
      "Creative assets",
      "Media plan",
      "Ad setup",
      "Launch",
      "Optimization",
      "Dashboards",
      "Reports",
    ],
    skills: [
        { name: "Campaign Strategy", level: 88, description: "Clear objectives and messaging" },
        { name: "Ad Creative Production", level: 92, description: "Visuals designed for performance" },
        { name: "Media Formats", level: 85, description: "Digital, social, and display ads" },
        { name: "Performance Review", level: 80, description: "Creative optimization cycles" }
      ],
    timeline: "3–8 weeks or Retainer",
    priceFrom: "KES 200,000",
    price: 200000,
    image:
      "https://img.rocket.new/generatedImages/rocket_gen_img_1eb918af9-1764668059026.png",
    alt: "Marketing analytics",
    iconName: "Megaphone",
    color: "from-primary/90 to-accent/90",
    link: "/corporate-solutions-services#campaign-engineering",
  },
];
